import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Label,
  Breadcrumb,
  BreadcrumbItem,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import toast from "react-hot-toast";
import { TextField } from "@material-ui/core";
import { MdAttachFile } from "react-icons/md";
import { Autocomplete } from "@material-ui/lab";

// Componentes
import CustomModal from "../../../components/modales/customModal";
import Loading from "../../../components/modales/loadingModal";

// Utils
import { glosarioRequisicionEmpleo } from "../utils/glosarioSolicitudes";
import { singleFileUploader } from "../../../utils/FirebaseStorage/FirebaseStorage";

//Redux
import { connect } from "react-redux";

//API Calls
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";

const cantidadAPE = functionsHttpsCallable("ape_getNumeroSolicitudes");
const crearAPE = functionsHttpsCallable("ape_crearSolicitudEmpleo");
const editarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");
const envioCorreo = functionsHttpsCallable("correos_envioCorreoAPE");
const getFlujo = functionsHttpsCallable("ape_getFlujo");
const getOpcionesCreacion = functionsHttpsCallable("ape_getOpcionesCreacion");
const getContratos = functionsHttpsCallable("ape_getContratos");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const ModalCreacion = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [dataProcesoVal, setDataProcesoVal] = useState(false);
  const [generalState, setGeneralState] = useState({});
  const [generalValidation, setGeneralValidation] = useState(false);
  const [camposObligatoriosValidation, setCamposObligatoriosValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [opcionesSelect, setOpcionesSelect] = useState({});
  const [informacionPersonas, setInformacionPersonas] = useState({});
  const [updFileArr, setUpdFileArr] = useState([]);
  const [recursoArr, setRecursoArr] = useState([]);
  const [auxiliosArr, setAxuliosArr] = useState([]);
  const [auxiliosDiarioArr, setAxuliosDiarioArr] = useState([]);
  const [tempAuxVal, setTempAuxVal] = useState(0);
  const [tempAuxId, setTempAuxId] = useState(0);
  const [tempAuxDiarioVal, setTempAuxDiarioVal] = useState(0);
  const [tempAuxDiarioId, setTempAuxDiarioId] = useState(0);
  const [userId, setUserId] = useState(parseInt(userData.userId));

  
  const adjuntos = [
    {
      key: "MANUAL",
      name: "Manual",
      type: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/msword",
      ],
    },
    {
      key: "PERFIL_CARGO",
      name: "Perfil del Cargo",
      type: ["application/pdf"],
    },
    { key: "ATA", name: "ATA", type: [] },
  ];

  useEffect(() => {
    const getDataInicialCreacionFunc = async () => {
      await getOpcionesSelect();
    };
    if (userId && props.modal) {
      getDataInicialCreacionFunc();
    }
    setGeneralState(getEstadoInicial());
  }, [userId, props.modal]);

  useEffect(() => {
    if (generalState.tipoContrato === "OBRA O LABOR")
      setGeneralValidation(generalState.descripcionObraLabor.length > 10);
  }, [generalState]);

  // Función para validar los 3 campos obligatorios nuevos
  const validarCamposObligatorios = () => {
    const camposObligatorios = ['educacion', 'formacion', 'experiencia'];
    
    for (const campo of camposObligatorios) {
      // Verificar que el campo existe en el estado
      if (!generalState[campo] || !generalState[campo].valor) {
        console.log(`[VALIDACIÓN] Campo ${campo} no existe o no tiene valor:`, generalState[campo]);
        return false;
      }
      
      // Obtener el valor (puede ser string o objeto con propiedad value)
      const valor = generalState[campo].valor;
      let valorFinal = valor;
      
      // Si es un objeto, obtener el valor de la propiedad value
      if (typeof valor === 'object' && valor !== null && valor.value !== undefined) {
        valorFinal = valor.value;
      }
      
      // Verificar que el valor final no esté vacío
      if (!valorFinal || valorFinal === "") {
        console.log(`[VALIDACIÓN] Campo ${campo} está vacío. Valor:`, valor, 'ValorFinal:', valorFinal);
        return false;
      }
      
      console.log(`[VALIDACIÓN] Campo ${campo} OK. Valor:`, valorFinal);
    }
    console.log('[VALIDACIÓN] Todos los campos obligatorios están llenos');
    return true;
  };

  // Validación separada para los 3 campos obligatorios nuevos (sin afectar validación existente)
  useEffect(() => {
    const camposLlenos = validarCamposObligatorios();
    console.log('[VALIDACIÓN] Resultado:', camposLlenos, 'CamposObligatoriosValidation se pondrá en:', !camposLlenos);
    setCamposObligatoriosValidation(!camposLlenos);
  }, [generalState]);

  useEffect(() => {
    setInformacionPersonas(opcionesSelect.dataProceso);
  }, [opcionesSelect]);

  const createSolicitud = async () => {
    try {
      const cantidad = await cantidadAPE({ cod_empr: userData.codigoEmpresa });
      let i = 1;
      props.setModalTransaction(true);
      let solicitudes = [];
      let dataCreacion = getDataCreacion();
      const flujoReq = await getFlujo({
        userId: userId,
        cod_empr: userData.codigoEmpresa,
        idCentroCosto: getIdCentroCosto(dataCreacion.cod_cost),
      });
      while (i <= parseInt(dataCreacion.num_plzs)) {
        let body = {
          cod_actu: flujoReq.data.data.cod_1apr,
          ...dataCreacion,
          ...flujoReq.data.data,
          cod_empr: userData.codigoEmpresa,
          cod_soli: cantidad.data.data.solicitudes + i,
        };
        const request = await crearAPE(body);
        await handleUpload(request);
        solicitudes.push(parseInt(request.data.data));
        let correoData = {
          tipo: "nuevo",
          // codigoAPE: request.data.data,
          estado: "APROBACION1",
          enviarA: [
            flujoReq.data.data.cod_1apr_email,
            flujoReq.data.data.cod_2apr_email,
            flujoReq.data.data.cod_3apr_email,
            flujoReq.data.data.cod_4apr_email,
            flujoReq.data.data.cod_recl_email,
            flujoReq.data.data.cod_cont_email,
            userData.email,
          ],
        };
        // await envioCorreo(correoData)
        i++;
      }
      if (solicitudes.length > 1) {
        for (const ape of solicitudes) {
          let updateData = {
            cod_empr: userData.codigoEmpresa,
            cod_soli: ape,
            data: {
              flg_grup: true,
              lis_grip: solicitudes,
            },
          };
          await editarAPE(updateData);
          toastSuccess(`Solicitud ${ape} creada!`);
        }
      } else {
        toastSuccess(`Solicitud ${solicitudes[0]} creada!`);
      }
      // props.toggle()
      props.setModalTransaction(false);
    } catch (e) {
      console.log("error", e);
      toastError(`${e}`);
      props.setModalTransaction(false);
    }
  };

  const FileUploader = (props) => {
    return (
      <div className={"FileUploader-style"}>
        <input
          type="file"
          id={`uploadAssetsInput_${props.step}`}
          onChange={(e) => {
            handleAddFile({
              step: props.step,
              type: props.type,
              file: e.target.files[0],
            });
          }}
          style={{ display: "none" }}
        />
        <IconButton
          aria-label="Add"
          onClick={() => {
            document.getElementById(`uploadAssetsInput_${props.step}`).click();
          }}
        >
          <MdAttachFile size={16} />
        </IconButton>
      </div>
    );
  };

  const handleAddFile = (file) => {
    if (file.type.includes(file.file.type) || file.type.length === 0) {
      toastSuccess("Archivo agregado!");
      let tempArr = [...updFileArr];
      tempArr.push(file);
      setUpdFileArr(tempArr);
    } else {
      toastError(`Tipo de archivo no valido`);
    }
  };

  const handleUpload = async (id) => {
    try {
      for (const file of updFileArr) {
        await singleFileUploader(
          file.file,
          `APEFiles/${id.data.data}`,
          `${file.step}${file.file.name.substring(
            file.file.name.lastIndexOf(".")
          )}`
        );
      }
      toastSuccess("Archivo Cargado!");
    } catch (error) {
      console.log(error);
      toastError("Error al cargar archivo");
    }
  };

  const getDataCreacion = () => {
    let fecha = new Date(new Date(Date.now()).getTime() - 5 * 60 * 60 * 1000);
    let data = {
      nom_gere: userData.gerencia,
      cod_empr: parseInt(userData.codigoEmpresa),
      cod_carg: generalState.cargo.valor ? generalState.cargo.valor : "",
      cod_crea: userId ? parseInt(userId) : 0,
      cod_crea_mail: userData.email,
      cod_crea_name: userData.nombre,
      cod_crea_cargo: userData.cargo,
      cmp_stat: "APROBACION1",
      fec_ingr: new Date(generalState.fechaIngreso.valor).toISOString(),
      tip_vaca: generalState.tipoVacante.valor,
      nom_proc: generalState.proceso.valor
        ? returnTextFormated(generalState.proceso.valor)
        : "",
      cod_trrm: generalState.trabajadorReemplazar.valor
        ? returnTextFormated(generalState.trabajadorReemplazar.valor)
        : "",
      cmp_cont: generalState.tipoContractual.valor
        ? generalState.tipoContractual.valor.toUpperCase()
        : "",
      clt_come: generalState.clienteComercial.valor
        ? returnTextFormated(generalState.clienteComercial.valor)
        : "",
      num_cont: generalState.clienteComercial.valor
        ? generalState.clienteComercial.valor
        : "",
      cod_care: generalState.itemCobro.valor
        ? generalState.itemCobro.valor
        : "",
      cod_ataa: generalState.codigoATA.valor
        ? generalState.codigoATA.valor
        : "",
      cod_cost: generalState.centroCosto.valor
        ? returnTextFormated(generalState.centroCosto.valor)
        : "",
      cmp_pep: generalState.pep.valor,
      cod_camp: generalState.campo.valor
        ? returnTextFormated(generalState.campo.valor)
        : "",
      nom_espc: generalState.especialidad.valor
        ? returnTextFormated(generalState.especialidad.valor)
        : "",
      dur_cont:
        generalState.duracionContrato.valor !== "" ||
        generalState.duracionContrato.valor !== 0
          ? generalState.duracionContrato.valor
          : "--",
      tip_cont: generalState.tipoContrato.valor,
      tip_nomn: generalState.nomina.valor,
      slc_tsal: generalState.tipoSalario.valor
        ? generalState.tipoSalario.valor.toUpperCase()
        : "",
      cmp_sala: generalState.salario.valor,
      cod_jefe: generalState.jefeInmediato.valor
        ? returnTextFormated(generalState.jefeInmediato.valor)
        : "",
      tip_turn: generalState.turno.valor
        ? returnTextFormated(generalState.turno.valor)
        : "",
      fun_cond: generalState.conductor.valor,
      cmp_obsr: generalState.observaciones.valor,
      num_plzs: generalState.numeroPlazas.valor,
      cmp_admn: generalState.tipoAdmin.valor,
      cmp_caus: generalState.causaReemplazo.valor
        ? generalState.causaReemplazo.valor
        : "",
      fec_recl: fecha.toISOString(),
      fec_cont: fecha.toISOString(),
      ced_cand: 0,
      tip_carg: generalState.tipoCargo.valor
        ? generalState.tipoCargo.valor
        : "",
      educacion: generalState.educacion && generalState.educacion.valor
        ? (typeof generalState.educacion.valor === 'object' && generalState.educacion.valor.value 
          ? generalState.educacion.valor.value 
          : generalState.educacion.valor)
        : "",
      formacion: generalState.formacion && generalState.formacion.valor
        ? (typeof generalState.formacion.valor === 'object' && generalState.formacion.valor.value 
          ? generalState.formacion.valor.value 
          : generalState.formacion.valor)
        : "",
      experiencia: generalState.experiencia && generalState.experiencia.valor
        ? (typeof generalState.experiencia.valor === 'object' && generalState.experiencia.valor.value 
          ? generalState.experiencia.valor.value 
          : generalState.experiencia.valor)
        : "",
      cmp_rec: recursoArr.length > 0 ? recursoArr : [],
      descripcionObraLabor: generalState.descripcionObraLabor.valor
        ? generalState.descripcionObraLabor.valor
        : "",
      contrato: generalState.contrato.valor ? generalState.contrato.valor : "",
    };
    auxiliosArr.forEach((aux) => {
      data[aux.id] = parseInt(aux.value);
    });
    auxiliosDiarioArr.forEach((aux) => {
      data[aux.id] = parseInt(aux.value);
    });
    return data;
  };

  const getIdCentroCosto = (centroCosto) => {
    if (
      centroCosto.includes(".1") ||
      centroCosto.includes(".2") ||
      centroCosto.includes(".3")
    ) {
      return centroCosto.slice(0, 13);
    } else return centroCosto.slice(0, 11);
  };

  const getEstadoInicial = () => {
    let estadoInicial = {};
    setAxuliosArr([]);
    setTempAuxId(0);
    setTempAuxVal(0);
    glosarioRequisicionEmpleo.map((input) => {
      if (input.type === "date") {
        estadoInicial[input.name] = {};
        estadoInicial[input.name]["valor"] = new Date(
          new Date(Date.now()).getTime() + 30 * 86400000
        );
        estadoInicial[input.name]["validation"] = true;
      } else if (
        input.name === "causaReemplazo" ||
        input.name === "duracionContrato"
      ) {
        estadoInicial[input.name] = {};
        estadoInicial[input.name]["valor"] = "";
        estadoInicial[input.name]["validation"] = true;
      } else if (input.name === "numeroPlazas") {
        estadoInicial[input.name] = {};
        estadoInicial[input.name]["valor"] = 1;
        estadoInicial[input.name]["validation"] = true;
      } else if (input.name === "recursos") {
        estadoInicial[input.name] = {};
        estadoInicial[input.name]["validation"] = true;
      } else if (input.type !== "divider") {
        estadoInicial[input.name] = {};
        estadoInicial[input.name]["valor"] = "";
        estadoInicial[input.name]["validation"] = false;
      }
    });
    return estadoInicial;
  };

  const getOpcionesSelect = async () => {
    const body = {
      cod_empr: userData.codigoEmpresa,
    };
    let opciones = await getOpcionesCreacion(body);
    let contratos = await getOpcionesContratos();
    setOpcionesSelect(opciones.data.data);
    setLoading(false);
    setDataProcesoVal(true);
  };

  const getOpcionesContratos = async () => {
    const req = await getContratos({
      cod_empr: 537,
    });
  };

  const handleAddRecurso = (checked, key) => {
    const tempArr = [...recursoArr];
    if (checked) {
      const pos = tempArr.indexOf(key);
      if (pos < 0) tempArr.push(key);
    } else {
      const pos = tempArr.indexOf(key);
      if (pos >= 0) tempArr.splice(pos, 1);
    }
    setRecursoArr([...tempArr]);
    let tempEstado = generalState;
    if (tempArr.length > 0) {
      tempEstado.recursos.validation = true;
    } else {
      tempEstado.recursos.validation = false;
    }
    setGeneralState({ ...tempEstado });
  };

  const handleAddAux = () => {
    const tempArr = [...auxiliosArr];
    tempArr.push({ id: tempAuxId.id, name: tempAuxId.name, value: tempAuxVal });
    setAxuliosArr([...tempArr]);
  };

  const handleAddDiarioAux = () => {
    const tempArr = [...auxiliosDiarioArr];
    tempArr.push({
      id: tempAuxDiarioId.id,
      name: tempAuxDiarioId.name,
      value: tempAuxDiarioVal,
    });
    setAxuliosDiarioArr([...tempArr]);
  };

  const getTipoComponente = (input) => {
    let validation = validarRender(input);
    if (validation) {
      switch (input.type) {
        case "inputText":
          if (input.numeric) {
            return (
              <Col key={`col_${input.name}`} lg="6" md="6" xs="12">
                <TextField
                  variant="outlined"
                  required
                  inputProps={{ type: "number" }}
                  autoComplete="off"
                  error={
                    !generalState[input.name].validation &&
                    generalState[input.name].valor.length > 0
                  }
                  key={`key_${input.name}`}
                  id={`input_${input.name}`}
                  fullWidth
                  label={input.label}
                  onChange={(e) =>
                    updateState(input.name, e.target.value, input.type)
                  }
                  defaultValue={input.defaultValue ?? ""}
                  helperText="Valores sin puntos o comas"
                  margin="normal"
                />
              </Col>
            );
          } else {
            return (
              <Col key={`col_${input.name}`} lg="6" md="6" xs="12">
                <TextField
                  variant="outlined"
                  required
                  autoComplete="off"
                  error={
                    !generalState[input.name].validation &&
                    generalState[input.name].valor.length > 0
                  }
                  key={`key_${input.name}`}
                  id={`input_${input.name}`}
                  fullWidth
                  label={input.label}
                  onChange={(e) => {
                    let valor = e.target.value;
                    // Convertir a mayúsculas para formacion y experiencia mientras se escribe
                    if (input.name === "formacion" || input.name === "experiencia") {
                      valor = valor.toUpperCase();
                    }
                    updateState(input.name, valor, input.type);
                  }}
                  value={generalState[input.name] ? generalState[input.name].valor : ""}
                  margin="normal"
                />
              </Col>
            );
          }
        case "inputTextLargo":
          return (
            <Col key={`col_${input.name}`} lg="12" md="12" xs="12">
              <TextField
                variant="outlined"
                required
                multiline
                key={`key_${input.name}`}
                id={`input_${input.name}`}
                fullWidth
                label={input.label}
                onChange={(e) =>
                  updateState(input.name, e.target.value, input.type)
                }
                defaultValue=""
                margin="normal"
              />
            </Col>
          );
        case "checkbox":
          return input.options.map((option) => {
            return (
              <Col
                className="checkbox-area"
                key={`col_${option.value}`}
                lg="5"
                md="5"
                xs="12"
              >
                <Input
                  type="checkbox"
                  onChange={(e) =>
                    handleAddRecurso(e.target.checked, option.value)
                  }
                />
                <Label check>{option.value}</Label>
              </Col>
            );
          });
        case "unique1":
          return (
            <Col lg="12" md="12" xs="12">
              {auxiliosArr.map((aux, index) => {
                return (
                  <Row style={{ marginBottom: "5px" }}>
                    <Col lg="6" md="6" xs="12">
                      <TextField
                        fullWidth
                        variant="outlined"
                        defaultValue={aux.name}
                        disabled
                      />
                    </Col>
                    <Col lg="6" md="6" xs="12">
                      <TextField
                        fullWidth
                        variant="outlined"
                        defaultValue={aux.value}
                        disabled
                      />
                    </Col>
                  </Row>
                );
              })}
              <Row style={{ alignItems: "center" }}>
                <Col lg="5" md="5" xs="12">
                  <Autocomplete
                    required
                    variant="outlined"
                    margin="dense"
                    options={[
                      {
                        id: "auxilioAlimentacion",
                        name: "Auxilio de Alimentación",
                      },
                      {
                        id: "auxilioAlimentacionSIS",
                        name: "Auxilio de Alimentación S.I.S.",
                      },
                      {
                        id: "auxilioLocalizacion",
                        name: "Auxilio de Localización",
                      },
                      {
                        id: "auxilioMovilizacion",
                        name: "Auxilio de Movilización",
                      },
                      {
                        id: "auxilioMovilizacionSIS",
                        name: "Auxilio de Movilización S.I.S.",
                      },
                      { id: "bonificacionCIS", name: "Bonificación C.I.S." },
                      { id: "bonificacionSIS", name: "Bonificación S.I.S." },
                      {
                        id: "primaElSauceMansovar",
                        name: "Prima El Sauce Mansovar",
                      },
                      {
                        id: "primaHabitacionalCIS",
                        name: "Prima Habitacional C.I.S.",
                      },
                      {
                        id: "primaAlimentacionYAlojamientoMasaro",
                        name: "Prima Alimentacion y Alojamiento Mansaro",
                      },
                      {
                        id: "auxilioGaitanSIS",
                        name: "Auxilio Económico Gaitán S.I.S. Mensual",
                      },
                      {
                        id: "auxilioConvencionalECP",
                        name: "Auxilio Transporte Convecional ECP",
                      },
                      {
                        id: "subsidioConvencionalHabitacion",
                        name: "Subsidio Convencional Habitación",
                      },
                      {
                        id: "auxilioTransporteConv",
                        name: "Auxilio Transporte Conv.",
                      },
                      {
                        id: "bonificacionBeneficioBienestar",
                        name: "Bonificación Beneficio de Bienestar",
                      },
                    ]}
                    key={`key_TipoDeContrato`}
                    id={`select_TipoDeContrato`}
                    onChange={(event, newValue) => setTempAuxId(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Auxilio mensual"}
                        margin="normal"
                      />
                    )}
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                      <React.Fragment>{option.name}</React.Fragment>
                    )}
                  />
                </Col>
                <Col lg="5" md="5" xs="12">
                  <TextField
                    variant="outlined"
                    required
                    inputProps={{ type: "number" }}
                    autoComplete="off"
                    key={`key_input_aux`}
                    id={`input_aux`}
                    fullWidth
                    label={input.label}
                    onChange={(e) => setTempAuxVal(e.target.value)}
                    defaultValue={0}
                    helperText="Valor Mensual sin puntos o comas"
                    margin="normal"
                  />
                </Col>
                <Col lg="2" md="2" xs="12">
                  <Button
                    onClick={() => {
                      handleAddAux();
                    }}
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>
            </Col>
          );
        case "unique2":
          return (
            <Col lg="12" md="12" xs="12">
              {auxiliosDiarioArr.map((aux, index) => {
                return (
                  <Row style={{ marginBottom: "5px" }}>
                    <Col lg="6" md="6" xs="12">
                      <TextField
                        fullWidth
                        variant="outlined"
                        defaultValue={aux.name}
                        disabled
                      />
                    </Col>
                    <Col lg="6" md="6" xs="12">
                      <TextField
                        fullWidth
                        variant="outlined"
                        defaultValue={aux.value}
                        disabled
                      />
                    </Col>
                  </Row>
                );
              })}
              <Row style={{ alignItems: "center" }}>
                <Col lg="5" md="5" xs="12">
                  <Autocomplete
                    required
                    variant="outlined"
                    margin="dense"
                    options={[
                      {
                        id: "auxCaminanteNoSalarial",
                        name: "AUXILIO DE CAMINANTE NO SALARIAL",
                      },
                      {
                        id: "auxNoSalarialCasino",
                        name: "AUXILIO NO SALARIAL CASINO",
                      },
                      {
                        id: "auxProduccionYCampoSIS",
                        name: "AUXILIO DE PRODUCCION Y DE CAMPO S.I.S",
                      },
                      {
                        id: "auxAlimentacionDiario",
                        name: "AUXILIO ALIMENTACION DIARIO S.I.S",
                      },
                      {
                        id: "auxMovilizacionDiario",
                        name: "AUXILIO MOVILIZACION DIARIO S.I.S",
                      },
                      {
                        id: "auxLocalizacionDiario",
                        name: "AUXILIO LOCALIZACION DIARIO S.I.S",
                      },
                      { id: "auxLoncheSIS", name: "AUXILIO POR LONCHE S.I.S" },
                      {
                        id: "auxEspecialTransporteSIS",
                        name: "AUXILIO ESPECIAL DE TRANSPORTE SIS",
                      },
                      {
                        id: "auxEspecialAlimentacionSIS",
                        name: "AUXILIO ESPECIAL DE ALIMENTACION SIS",
                      },
                      {
                        id: "auxEspecialLejanias",
                        name: "AUXILIO ESPECIAL DE LEJANIAS",
                      },
                      {
                        id: "auxNoSalarialBloqueMatambo",
                        name: "AUXILIO NO SALARIAL BLOQUE MATAMBO",
                      },
                      {
                        id: "auxNoSalarialBloqueCampoRico",
                        name: "AUXILIO NO SALARIAL BLOQUE CAMPO RICO",
                      },
                      {
                        id: "auxViaticosTSA",
                        name: "AUXILIO POR VIATICOS TSA",
                      },
                      {
                        id: "auxTrabajoRemotoUtipecSIS",
                        name: "AUXILIO TRABAJO REMOTO UTIPEC SIS",
                      },
                      {
                        id: "auxNoSalarialBloqueMaranta",
                        name: "AUXILIO NO SALARIAL BLOQUE MARANTA",
                      },
                      {
                        id: "auxAlimentacionDiarioCIS",
                        name: "AUXILIO ALIMENTACION DIARIO C.I.S",
                      },
                      {
                        id: "auxViaticosEMO",
                        name: "AUXILIO POR VIATICOS EMO",
                      },
                      {
                        id: "auxEconomicoObrasMetalMecanica",
                        name: "AUXILIO ECONOMICO OBRAS METALMECANICA",
                      },
                      {
                        id: "auxTransporteDiarioSIS",
                        name: "AUXILIO DE TRANSPORTE DIARIO SIS",
                      },
                      {
                        id: "bonificacionCISDiario",
                        name: "Bonificación C.I.S. DIARIO",
                      },
                      {
                        id: "bonificacionSISDiario",
                        name: "Bonificación S.I.S. DIARIO",
                      },
                      {
                        id: "jornadaSuplementariaDiario",
                        name: "Jornada Suplementaria",
                      },
                    ]}
                    key={`key_TipoDeContrato`}
                    id={`select_TipoDeContrato`}
                    onChange={(event, newValue) => setTempAuxDiarioId(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Auxilio diario"}
                        margin="normal"
                      />
                    )}
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                      <React.Fragment>{option.name}</React.Fragment>
                    )}
                  />
                </Col>
                <Col lg="5" md="5" xs="12">
                  <TextField
                    variant="outlined"
                    required
                    inputProps={{ type: "number" }}
                    autoComplete="off"
                    key={`key_input_aux`}
                    id={`input_aux`}
                    fullWidth
                    label={input.label}
                    onChange={(e) => setTempAuxDiarioVal(e.target.value)}
                    defaultValue={0}
                    helperText="Valor diario sin puntos o comas"
                    margin="normal"
                  />
                </Col>
                <Col lg="2" md="2" xs="12">
                  <Button
                    onClick={() => {
                      handleAddDiarioAux();
                    }}
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>
            </Col>
          );
        case "select":
          if (input.options) {
            return (
              <Col key={`col_${input.name}`} lg="6" md="6" xs="12">
                <Autocomplete
                  variant="outlined"
                  required
                  margin="dense"
                  options={input.options}
                  key={`key_${input.name}`}
                  id={`select_${input.name}`}
                  onChange={(event, newValue) =>
                    updateState(
                      input.name,
                      newValue != null ? newValue : "",
                      input.type
                    )
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={input.label}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option.value}
                  renderOption={(option) => (
                    <React.Fragment>{option.value}</React.Fragment>
                  )}
                />
              </Col>
            );
          } else {
            return (
              <Col key={`col_${input.name}`} lg="6" md="6" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={
                    loading
                      ? []
                      : opcionesSelect[input.name] !== undefined
                      ? ["NO APLICA", ...opcionesSelect[input.name]]
                      : []
                  }
                  key={`key_${input.name}`}
                  id={`select_${input.name}`}
                  onChange={(event, newValue) =>
                    updateState(
                      input.name,
                      newValue != null ? newValue : "",
                      input.type
                    )
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={input.label}
                      margin="normal"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>{option ?? ``}</React.Fragment>
                  )}
                />
              </Col>
            );
          }

        case "date":
          return (
            <Col
              key={`col_${input.name}`}
              lg="6"
              md="6"
              xs="12"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <Label for="exampleSelect">{input.label}</Label>
              <Input
                id="endDate"
                name="datetime"
                disabled={input.disabled ? input.disabled : false}
                value={
                  generalState[input.name]
                    ? generalState[input.name]["valor"]
                        .toISOString()
                        .split("T")[0]
                    : new Date(Date.now().getTime() + 86400000)
                        .toISOString()
                        .split("T")[0]
                }
                onChange={(e) => updateState(input.name, e, input.type)}
                type="date"
              />
              <br />
              {/* <DateField
                                label={input.label}
                                value={generalState[input.name] ? generalState[input.name]['valor'].toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                                onChange={(e) => updateState(input.name, e, input.type)}
                                format="DD-MM-YYYY"
                            /> */}
            </Col>
          );
        case "divider":
          return (
            <Col key={`col_${input.name}`} lg="12" style={{ marginTop: "5px" }}>
              <Breadcrumb>
                <BreadcrumbItem className="BreadcrumbItem-color">
                  {input.label}
                </BreadcrumbItem>
              </Breadcrumb>
            </Col>
          );
        default:
          return (
            <Col key={`col_default`}>
              <Label>Texto</Label>
            </Col>
          );
      }
    }
  };

  const returnBody = () => {
    return glosarioRequisicionEmpleo.map((input) => {
      return getTipoComponente(input);
    });
  };

  const returnTextFormated = (text) => {
    let newText = text.split(" ");
    let returnText = "";
    newText.forEach((word, index) => {
      if (word !== "") {
        if (index > 0) {
          returnText = returnText + " " + word;
        } else {
          returnText = word;
        }
      }
    });
    return returnText;
  };

  const updateState = (name, value, type) => {
    let estado = generalState;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (name === "salario") {
      estado[name]["valor"] = value;
      estado[name]["validation"] = !format.test(value);
    } else if (type === "date") {
      estado[name]["valor"] = new Date(value.target.value);
      estado[name]["validation"] = true;
    } else {
      // Obtener el valor (puede ser objeto con value o string directo)
      let valorSinProcesar = value.value ? value.value : value ? value : "";
      
      // Convertir a mayúsculas para los campos formacion y experiencia
      if (name === "formacion" || name === "experiencia") {
        valorSinProcesar = typeof valorSinProcesar === 'string' ? valorSinProcesar.toUpperCase() : valorSinProcesar;
      }
      
      estado[name]["valor"] = valorSinProcesar;
      estado[name]["validation"] = getValueValidation(value);
    }
    setGeneralState({ ...estado });
  };

  const getValueValidation = (value) => {
    try {
      if (value.value !== undefined && value.value.length > 0) {
        return true;
      } else if (value !== undefined && value.length > 0) {
        return true;
      } else return false;
    } catch (error) {
      return false;
    }
  };
  const validarRender = (input) => {
    switch (input.name) {
      case "causaReemplazo":
        if (
          generalState.tipoVacante.valor !== undefined &&
          generalState.tipoVacante.valor !== null
        ) {
          if (generalState.tipoVacante.valor === "REEMPLAZO") return true;
          else return false;
        } else return false;
      case "duracionContrato":
        if (
          generalState.tipoContrato.valor !== undefined &&
          generalState.tipoContrato.valor !== null
        ) {
          if (
            generalState.tipoContrato.valor === "FIJO" ||
            generalState.tipoContrato.valor === "APRENDIZAJE"
          )
            return true;
          else return false;
        } else return false;
      case "descripcionObraLabor":
        if (
          generalState.tipoContrato.valor !== undefined &&
          generalState.tipoContrato.valor !== null
        ) {
          if (generalState.tipoContrato.valor === "OBRA O LABOR") return true;
          else return false;
        } else return false;
      default:
        return true;
    }
  };

  return (
    <React.Fragment>
      <CustomModal
        modal={props.modal}
        toggle={() => {
          setUpdFileArr([]);
          props.toggle();
        }}
        title={"Solicitud de Empleo"}
        buttonTitle={"Crear"}
        buttonLoading={!(updFileArr.length >= 2 && !generalValidation && !camposObligatoriosValidation)}
        // buttonLoading={false}
        // enableOk={true}
        onClick={() => createSolicitud()}
        // onClick={() => getDataCreacion()}
      >
        <Row>
          {dataProcesoVal ? (
            returnBody()
          ) : (
            <div className={"loading-area"}>
              <Loading />
            </div>
          )}
        </Row>
        <Row>
          {dataProcesoVal ? (
            <Col lg="12" md="12" xs="12">
              <ListGroup>
                {adjuntos.map((attachment, index) => {
                  // Extraer el valor de codigoATA (puede ser string o objeto)
                  let codigoATAValor = "";
                  if (generalState.codigoATA && generalState.codigoATA.valor) {
                    codigoATAValor = typeof generalState.codigoATA.valor === 'object' && generalState.codigoATA.valor.value
                      ? generalState.codigoATA.valor.value
                      : generalState.codigoATA.valor;
                    // Normalizar el valor (trim y convertir a string para comparación)
                    codigoATAValor = String(codigoATAValor).trim().toUpperCase();
                  }
                  
                  // Mostrar adjunto ATA solo si codigoATA NO es "NO APLICA" y no está vacío
                  const mostrarAdjuntoATA = attachment.key === "ATA" 
                    ? (codigoATAValor !== "NO APLICA" && codigoATAValor !== "")
                    : true;
                  
                  if (mostrarAdjuntoATA) {
                    return (
                      <ListGroupItem
                        className="listItem-display-content listItem-card-attachment"
                        key={`lisItem_contratacion_${attachment.key}`}
                        color={
                          updFileArr.findIndex(
                            (i) => i.step === `${attachment.key}`
                          ) >= 0
                            ? "success"
                            : "warning"
                        }
                      >
                        <div
                          key={`div_${attachment.key}`}
                          className="reclutamiento-list-area"
                        >
                          {`Adjunto ${attachment.name}`}
                          {
                            <FileUploader
                              step={attachment.key}
                              type={attachment.type}
                            />
                          }
                        </div>
                      </ListGroupItem>
                    );
                  }
                })}
              </ListGroup>
            </Col>
          ) : null}
        </Row>
      </CustomModal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ModalCreacion);
